import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageWrapperComponent } from './page-wrapper.component';
import { IonicModule } from '@ionic/angular';
import { ButtonModule } from '../button/button.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { HeaderSearchBarModule } from '../header-search-bar/header-search-bar.module';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [PageWrapperComponent],
    imports: [CommonModule, IonicModule, ButtonModule, HeaderSearchBarModule, TooltipModule, NgbDropdownModule],
    exports: [PageWrapperComponent],
})
export class PageWrapperModule {}
